import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngular,
  faEmber,
  faPhp,
  faPython,
  faReact,
  faVuejs,
} from '@fortawesome/free-brands-svg-icons';
import {
  faAdjust,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsAltH,
  faArrowsAltV,
  faAsterisk,
  faBan,
  faBookOpen,
  faBullseye,
  faCalculator,
  faCalendarAlt,
  faCameraRetro,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClipboardCheck,
  faClock,
  faClone,
  faCode,
  faCog,
  faComment,
  faCommentAlt,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faFlag,
  faFont,
  faGem,
  faGlobe,
  faImage,
  faInfo,
  faInfoCircle,
  faLevelDownAlt,
  faList,
  faLock,
  faLongArrowAltRight,
  faMagic,
  faMap,
  faMinus,
  faMinusCircle,
  faPalette,
  faPen,
  faPencilAlt,
  faPlus,
  faPlusCircle,
  faPrint,
  faQuestionCircle,
  faSearch,
  faShare,
  faSignOutAlt,
  faSlidersH,
  faSort,
  faStar,
  faTag,
  faTh,
  faThLarge,
  faThList,
  faTimes,
  faTrash,
  faTrashAlt,
  faUpload,
  faUser,
  faUserCircle,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

import { far } from '@fortawesome/free-regular-svg-icons';

export const registered = [
  faAngular,
  faEmber,
  faPhp,
  faPython,
  faReact,
  faVuejs,
  faAdjust,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsAltH,
  faArrowsAltV,
  faAsterisk,
  faBan,
  faBookOpen,
  faBullseye,
  faCalculator,
  faCalendarAlt,
  faCameraRetro,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClipboardCheck,
  faClock,
  faClone,
  faCode,
  faCog,
  faComment,
  faCommentAlt,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faFlag,
  faFont,
  faGem,
  faGlobe,
  faImage,
  faInfo,
  faInfoCircle,
  faLevelDownAlt,
  faList,
  faLock,
  faLongArrowAltRight,
  faMagic,
  faMap,
  faMinus,
  faMinusCircle,
  faPalette,
  faPen,
  faPencilAlt,
  faPrint,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faSearch,
  faShare,
  faSignOutAlt,
  faSlidersH,
  faSort,
  faStar,
  faTag,
  faTh,
  faThLarge,
  faThList,
  faTimes,
  faTrash,
  faTrashAlt,
  faUpload,
  faUser,
  faUserCircle,
  faUsers,
  far,
];

library.add(...registered);

// FIXME: remove this once component library is removed
// (CCheckbox and CColorPickerDropdown uses CFontIcon internally
// and we need to display those icons still)
dom.watch();
